module.exports = __webpack_public_path__ + "static/media/hs_02.006aee95.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/heads/JPEG/hs_02.jpg
// module id = 5933
// module chunks = 0